import AdminDashboard from "./AdminDashboard";
// import EmployeeDashboard from "./EmployeeDashboard";

const Dashboard = () => {
  return (
    <AdminDashboard />
  );
};

export default Dashboard;
